// @flow

import Roarr from 'roarr';

const Logger = Roarr
  .child({
    package: 'mutual-exclusion',
  });

export default Logger;
